import { HttpClient, HttpHeaders, HttpParamsOptions } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject, observable} from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginDto } from '../../models/auth/login-dto.model';
import { BaseService } from '../base.service';
import {LoginResponseModel} from "../../models/auth/login-response.model";


@Injectable()
export class AuthenticationService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'authentication',
            httpClient);
    }

    authenticate(model: any): Observable<any> {

        var url = environment.baseUrl + "/auth/login";


        return this.httpClient.get(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    loginNew(): Observable<any> {

        var url = environment.baseUrl + "/auth/loginNew";


        return this.httpClient.get(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    loginNews(): Observable<LoginDto[]> {

        var url = environment.baseUrl + "/auth/loginNews";
        
        return this.httpClient.get<LoginDto[]>(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    login(entity: LoginDto): Observable<LoginResponseModel> {

        var url = environment.baseUrl + "/auth/login";

        return this.httpClient.post<LoginResponseModel>(url, entity, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )

    }

    loginToSubDomain(entity: LoginDto): Observable<any> {

        var url = environment.baseUrl + "/user/loginToSubDomain";

        return this.httpClient.post(url, entity, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )

    }

    loginMobile(entity: LoginDto): Observable<any> {

        var url = environment.baseUrl + "/user/loginMobile";

        const username = 'test';
        const password = 'test@xnrj?2019';

        const options = this.createRequestOption({username, password});

        return this.httpClient.post(url, entity, {params: options, observe: 'response'})
            .pipe(
                tap(),
                catchError(this.handleError)
            )

    }





    // TODO: impersonation !!!
}
